import {
  Card, CardContent, Typography, Chip, IconButton, ListItemIcon, ListItemText, Menu
} from '@material-ui/core';
import { observer } from "mobx-react";
import { makeStyles } from '@material-ui/core/styles';
import MoreVertIcon from "@material-ui/icons/MoreVert";
import EmailIcon from "@material-ui/icons/Email";
import PhoneIcon from "@material-ui/icons/Phone";
import { Edit, MoreHoriz, Person, Sms } from '@material-ui/icons';
import { useEffect, useState } from 'react';
import { MenuItem, StandardDialog } from '@roc/ui';
import { AddCadenceStepModal } from './addCadenceStepModal';
import { ProspectsViewer } from './cadenceDashboardStepsDue/prospectsViewer';
import { useStore } from '@roc/client-portal-shared/hooks';
import { DialerCallStepsDue } from './cadenceDashboardStepsDue/dialerCallStepsDue';
import { CallStepsDue } from './cadenceDashboardStepsDue/callStepsDue';
import { SendTextStepDueCadenceModal } from './cadenceDashboardStepsDue/textStepsDue';
import { MIXED_OBJECT_TYPE } from '../leads/constants/constants';
import { EmailStepsDue } from './cadenceDashboardStepsDue/emailStepsDue';
import { EmailTemplateStepsDue } from './cadenceDashboardStepsDue/emailTemplateStepsDue';

const useStyles = makeStyles(theme => ({
  containerRatesInfo: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    marginRight: "20px",
    gap: "4px",
  },
  iconContainer: {
    backgroundColor: "#F0F0F0",
    padding: "6px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "30px",
    height: "30px",
    minWidth: "30px"
  }
}));

export const CadenceStepsComponent = observer(({ index, step, shouldRenderActions, lenderByCompany, onClose }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [openAddCadenceModal, setOpenAddCadenceModal] = useState(false);
  const [openProspectViewerModal, setOpenProspectViewerModal] = useState(false);
  const [stepToEdit, setStepToEdit] = useState(null);
  const [filteredProspects, setFilteredProspects] = useState([]);
  const [openEmailStepDue, setOpenEmailStepDue] = useState(false);
  const [openTextStepDue, setOpenTextStepDue] = useState(false);
  const [openCallStepDue, setOpenCallStepDue] = useState(false);
  const [currentCadence, setCurrentCadence] = useState(null);
  const [openOtherStepDue, setOpenOtherStepDue] = useState(false);
  const { salesforceLeadStore, cadenceStore, userStore, salesforceLenderStore } = useStore();

  const menuOpen = Boolean(anchorEl);
  const classes = useStyles();

  const getStepIcon = (type: string) => {
    switch (type) {
      case "email":
        return <EmailIcon color="primary" />;
      case "phone":
        return <PhoneIcon color="secondary" />;
      case "text":
        return <Sms style={{ color: "#1877F2" }} />;
      case "other":
        return <MoreHoriz style={{ color: "primary" }} />;
      default:
        return null;
    }
  };

  const handleOpenEmailStepDueModal = () => setOpenEmailStepDue(true);
  const handleCloseEmailStepDueModal = () => {
    setOpenEmailStepDue(false);
    onClose()
  }

  const handleOpenTextStepDueModal = () => setOpenTextStepDue(true);
  const handleCloseTextStepDueModal = () => {
    salesforceLeadStore.ringCentralStore.resetLists()
    setOpenTextStepDue(false);
    onClose()
  }

  const handleOpenOtherStepDue = () => setOpenOtherStepDue(true);
  const handleCloseOtherStepDue = () => {
    setOpenOtherStepDue(false);
    onClose()
  }

  const handleOpenCallStepDueModal = () => {
    if (currentStep?.prospects) {
      cadenceStore.dialSession.setRecords(currentStep.prospects);
    }
    setOpenCallStepDue(true);
  };
  const handleCloseCallStepDueModal = () => {
    if (cadenceStore.dialSession?.completedRecordIds && cadenceStore.dialSession?.completedRecordIds.size > 0) {
      cadenceStore.dialSession.resetCompletedRecordIds();
      cadenceStore.fetchCadencesDueByBackofficeOriginatorAndCadenceId();
    }
    setOpenCallStepDue(false);
    onClose()
  };

  const handleClickableTypeForChip = (step) => {
    setCurrentCadence(cadenceStore.cadence);
    switch (step?.type) {
      case "email": handleOpenEmailStepDueModal(); break;
      case "phone": handleOpenCallStepDueModal(); break;
      case "text": handleOpenTextStepDueModal(); break;
      case "other": handleOpenOtherStepDue(); break;
      default: break;
    }
  };

  const handleOpenAddCadenceModal = (step) => {
    setStepToEdit(step);
    setOpenAddCadenceModal(true);
  };

  const handleCloseAddCadenceModal = () => {
    setOpenAddCadenceModal(false);
    setStepToEdit(null);
  };

  const handleCloseViewProspectsModal = () => {
    setOpenProspectViewerModal(false);
  };

  const openMenu = (event, step) => {
    setAnchorEl(event.currentTarget);
    setStepToEdit(step);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleOpenViewProspectsModal = (step) => {
    const filtered =
      cadenceStore?.cadence?.prospects?.filter(
        (p) => p?.cadenceContactInfo?.currentStep === step.stepNumber && p?.cadenceContactInfo?.active === true
      ) ?? [];

    setFilteredProspects(filtered);
    setOpenProspectViewerModal(true);
  };

  const dialerLimited = !!lenderByCompany?.limitedFunctionalitiesList?.includes(
    'dialerEnabled'
  );

  const cadences = cadenceStore.cadenceStepDueResponse?.stepDues ?? [];
  const findCurrentStep = (step) => {
    const currentStepName = `${cadenceStore.cadence.cadence}-${step.stepNumber}`;

    for (const cadence of cadences) {
      for (const cadenceStep of cadence.steps) {
        const compositeId = `${cadence.name}-${cadenceStep.cadenceStepsInfo?.stepNumber}`;
        if (compositeId === currentStepName) {
          cadenceStep.cadenceAssigneeId = cadence?.cadenceAssigneeId ?? null;
          return cadenceStep;
        }
      }
    }

    return null;
  };

  const currentStep = findCurrentStep(step);


  const getTotalFormDuesObject = (normalStep) => {
    if (!currentStep) return 0;

    if (currentStep?.cadenceStepsInfo?.stepNumber === normalStep?.stepNumber) return currentStep?.prospects?.length

    return 0;
  };

  return (
    <Card key={index} style={{ marginBottom: "8px", padding: "10px" }}>
      <CardContent style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <div className={classes.iconContainer}>
            {getStepIcon(step.type)}
          </div>

          <div style={{ display: "flex", flexDirection: "column" }}>
            <Typography variant="body1">
              Day {step.day} {step.title}
            </Typography>
          </div>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>

          <Chip
            label={`${cadenceStore.callingFromMyCadences ? getTotalFormDuesObject(step) : step.totalDue} Due`}
            color="primary"
            onClick={
              cadenceStore.callingFromMyCadences
                ? (e) => {
                  e.currentTarget.blur();
                  handleClickableTypeForChip(step);
                }
                : undefined
            }
            style={{
              cursor: cadenceStore.callingFromMyCadences ? 'pointer' : 'default'
            }}
          />

          {shouldRenderActions &&
            <IconButton onClick={e => openMenu(e, step)}>
              <MoreVertIcon />
            </IconButton>
          }

        </div>
      </CardContent>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={menuOpen}
        onClose={handleMenuClose}
      >
        <MenuItem testId='menuEdit' onClick={() => { handleOpenAddCadenceModal(step); handleMenuClose(); }}>
          <ListItemIcon><Edit fontSize="small" /></ListItemIcon>
          <ListItemText>Edit</ListItemText>
        </MenuItem>
        {!cadenceStore.callingFromMyCadences && <MenuItem testId='menuEdit' onClick={() => { handleOpenViewProspectsModal(step) }}>
          <ListItemIcon><Person fontSize="small" /></ListItemIcon>
          <ListItemText>View Prospects</ListItemText>
        </MenuItem>}
      </Menu>
      <AddCadenceStepModal openModal={openAddCadenceModal} handleCloseModal={handleCloseAddCadenceModal} stepToEdit={stepToEdit} />
      <StandardDialog
        open={openProspectViewerModal}
        title={"Prospects"}
        fullScreen
        handleClose={handleCloseViewProspectsModal}
        dialogContent={<ProspectsViewer prospects={filteredProspects} recordType={cadenceStore?.cadence?.recordType} />
        }
      />
      <StandardDialog
        open={openEmailStepDue}
        title={"Send Email Step Due"}
        maxWidth="lg"
        handleClose={handleCloseEmailStepDueModal}
        dialogContent={currentStep?.cadenceStepsInfo?.stepContent?.emailTemplateId ? <EmailTemplateStepsDue handleClose={handleCloseEmailStepDueModal} salesforceLeadStore={salesforceLeadStore} type={MIXED_OBJECT_TYPE} currentStep={currentStep} cadenceStore={cadenceStore} /> : <EmailStepsDue handleClose={handleCloseEmailStepDueModal} salesforceLeadStore={salesforceLeadStore} type={MIXED_OBJECT_TYPE} currentStep={currentStep} cadenceStore={cadenceStore} cadence={currentCadence} />}
      />
      <StandardDialog
        open={openTextStepDue}
        title={"Send Text Step Due"}
        maxWidth="md"
        handleClose={handleCloseTextStepDueModal}
        dialogContent={<SendTextStepDueCadenceModal handleClose={handleCloseTextStepDueModal} salesforceLeadStore={salesforceLeadStore} type={MIXED_OBJECT_TYPE} currentStep={currentStep} cadenceStore={cadenceStore} />}
      />
      <StandardDialog
        open={openCallStepDue}
        title={"Call Step Due"}
        fullScreen
        handleClose={handleCloseCallStepDueModal}
        dialogContent={
          dialerLimited
            ? <DialerCallStepsDue currentStep={currentStep} />
            : <CallStepsDue currentStep={currentStep} />
        } />
      <StandardDialog
        open={openOtherStepDue}
        title={currentStep?.cadenceStepsInfo?.title}
        fullScreen
        handleClose={handleCloseOtherStepDue}
        dialogContent={<CallStepsDue currentStep={currentStep} />}
      />
    </Card>
  );
});
